import React from 'react';
import { Text } from 'ink';
import type { ContextUsage } from '../../types';

interface ContextUsageIndicatorProps {
  contextUsage?: ContextUsage;
}

/** Only surface the context-window percentage once it reaches this level. */
const VISIBILITY_THRESHOLD_PERCENT = 50;

/**
 * Status-bar indicator showing how much of the agent's context window is in
 * use ("73% context used"). Absolute token counts are never shown.
 */
export const ContextUsageIndicator: React.FC<ContextUsageIndicatorProps> = React.memo(
  ({ contextUsage }) => {
    if (!contextUsage) return null;

    const { totalTokens, maxTokens } = contextUsage;
    if (!Number.isFinite(totalTokens) || !Number.isFinite(maxTokens) || maxTokens <= 0) {
      return null;
    }

    const percent = Math.min(100, Math.round((totalTokens / maxTokens) * 100));
    if (percent < VISIBILITY_THRESHOLD_PERCENT) return null;

    return <Text dimColor>{percent}% context used</Text>;
  },
);
